import { EpimsBaseEntityDto } from './epim-base.dto';

export class PLActivityActionPersonsDto extends EpimsBaseEntityDto{

  PLStageActivityId: string;
  SubscriptionUserId: string;
  StaffId: string;
  StaffName: string;
  
  }
